import type { WorkSpace } from 'features/workspace'

import { type Dispatch, type SetStateAction, useMemo } from 'react'

import { type AppWorkingHours, DAYS } from './utils'

const useHasSelected = (hours: AppWorkingHours) =>
	useMemo(() => DAYS.some(key => hours[key].isSelected), [hours])

const useDateHandlers = (setter: Dispatch<SetStateAction<AppWorkingHours>>) =>
	useMemo(
		() => ({
			handleHoursChange: (day: WorkSpace.WeekDayName, value: string) =>
				setter(previous => {
					const next = { ...previous[day] }
					next.value = value

					return { ...previous, [day]: next }
				}),

			toggleDay: (day: WorkSpace.WeekDayName) =>
				setter(previous => {
					const next = { ...previous[day] }
					next.isSelected = !next.isSelected

					return { ...previous, [day]: next }
				})
		}),
		[setter]
	)

export { useDateHandlers, useHasSelected }
